"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("../CarrierLogo/constant");
var _constant3 = require("./constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    carrierLogoCustomProperties: _propTypes.default.object,
    carrierSize: _propTypes.default.string,
    carriers: _propTypes.default.arrayOf(_propTypes.default.shape({
      name: _propTypes.default.string,
      type: _propTypes.default.string,
      code: _propTypes.default.string,
      image: _propTypes.default.string
    })),
    designator: _propTypes.default.shape({
      departureStation: _propTypes.default.string,
      arrivalStation: _propTypes.default.string,
      departureTime: _propTypes.default.string,
      arrivalTime: _propTypes.default.string
    }),
    tripType: _propTypes.default.string,
    segments: _propTypes.default.arrayOf(_propTypes.default.shape({
      designator: _propTypes.default.shape({
        departureStation: _propTypes.default.string,
        arrivalStation: _propTypes.default.string,
        departureTime: _propTypes.default.string,
        arrivalTime: _propTypes.default.string
      }),
      duration: _propTypes.default.number,
      layoverTime: _propTypes.default.number
    })),
    translation: _propTypes.default.shape({
      stopAt: _propTypes.default.string,
      hour: _propTypes.default.string,
      minute: _propTypes.default.string,
      depart: _propTypes.default.string,
      return: _propTypes.default.string,
      nonStop: _propTypes.default.string,
      singleStop: _propTypes.default.string,
      multiStop: _propTypes.default.string,
      subjectToGovtApproval: _propTypes.default.string
    }),
    depart: _propTypes.default.bool,
    shoStopoverText: _propTypes.default.bool,
    stopoverSize: _propTypes.default.string,
    isMobile: _propTypes.default.bool,
    containerStyle: _propTypes.default.string,
    showDetailedStop: _propTypes.default.bool,
    locale: _propTypes.default.string,
    hourCycle: _propTypes.default.number,
    isSubjectToGovtApproval: _propTypes.default.bool,
    useLocalTimezone: _propTypes.default.bool,
    showStackedImages: _propTypes.default.bool,
    unifiedConfirmationPageProp: _propTypes.default.bool,
    isViDisclaimer: _propTypes.default.bool,
    isSoldOut: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    carriers: [],
    designator: {},
    tripType: _constant3.TRIP_TYPES.oneway,
    segments: [],
    translation: {},
    depart: true,
    shoStopoverText: true,
    carrierSize: _constant2.SIZES.SMALL,
    stopoverSize: _constant2.SIZES.SMALL,
    isMobile: false,
    containerStyle: 'space-between',
    carrierLogoCustomProperties: {},
    showDetailedStop: true,
    locale: 'en-gb',
    hourCycle: 12,
    isSubjectToGovtApproval: false,
    useLocalTimezone: false,
    showStackedImages: false,
    unifiedConfirmationPageProp: false,
    isViDisclaimer: false,
    isSoldOut: false
  }
};
exports.default = _default;